export default __webpack_public_path__ + "static/media/close-white.6edde1ae.svg";